const decrementFontSize = ($element) => {

    const lastSize = (
        parseInt(
            $element
                .css('font-size')
                .slice(0, -2)
        )
    );

    const newSize = (lastSize - 1) / 16;

    return $element.css('font-size', `${newSize}rem`);
};

export const fitText = (element) => {

    const $element = $(element);

    if ($element.length === 0) {
        return;
    }

    $element.css('font-size', '');

    while (element.offsetWidth < element.scrollWidth) {
        decrementFontSize($element);
    }
};

